import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../config';
import * as i0 from "@angular/core";
import * as i1 from "../config/config.service";
var DevImpersonationHttpService = /** @class */ (function () {
    function DevImpersonationHttpService(configService) {
        this.configService = configService;
    }
    /**
     * Request impersonation from the backend
     */
    DevImpersonationHttpService.prototype.impersonate = function (request) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dev/impersonate';
            var params = {
                body: request
            };
            API.post(_this.configService.get('host'), path, params)
                .then(function (result) {
                var response = result && result.data ? result.data : result;
                if (!response || !response.token || !response.expiresIn) {
                    observer.error(new Error('Impersonation response missing token'));
                    return;
                }
                var tokenData = {
                    token: response.token,
                    role: request.role,
                    distiId: request.distiId || null,
                    marketId: request.marketId || null,
                    clientId: request.clientId || null,
                    campusId: request.campusId || null,
                    portalView: request.portalView || 'ops',
                    expiresAt: Math.floor(Date.now() / 1000) + response.expiresIn
                };
                observer.next(tokenData);
                observer.complete();
            })
                .catch(function (err) {
                console.error('Impersonation error:', err);
                observer.error(err);
            });
        });
    };
    DevImpersonationHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DevImpersonationHttpService_Factory() { return new DevImpersonationHttpService(i0.ɵɵinject(i1.ConfigService)); }, token: DevImpersonationHttpService, providedIn: "root" });
    return DevImpersonationHttpService;
}());
export { DevImpersonationHttpService };
